import { CopyAll as CopyIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import type { Dayjs } from "dayjs";
import type { FC, ReactNode } from "react";
import { useState } from "react";
import { copyToClipboard } from "../../misc/copyToClipboard";

const dateFormat = "DD-MM-YYYY";

export interface NoteTS {
  readonly text: string;
  readonly date: Dayjs;
  readonly author: string;
  readonly tooltip?: string;
}

export interface NoteStampedListProps {
  readonly values: NoteTS[];
  readonly showCopy?: boolean;
  readonly onRemove?: (index: number, note: NoteTS) => void | Promise<void>;
  readonly renderActions?: (index: number) => ReactNode;
}

export const NoteStampedList: FC<NoteStampedListProps> = ({ values, showCopy, onRemove, renderActions }) => {
  const [expanded, setExpanded] = useState<number | null>(null);
  const showSecondaryActions = !!onRemove || showCopy || !!renderActions;
  return (
    <List>
      {values.map((value, idx) => (
        <ListItem
          key={idx}
          onClick={() => setExpanded(expanded === idx ? null : idx)}
          secondaryAction={
            showSecondaryActions ? (
              <>
                {renderActions?.(idx)}
                {showCopy && (
                  <IconButton title="Kopiuj tekst" onClick={() => copyToClipboard(value.text)}>
                    <CopyIcon />
                  </IconButton>
                )}
                {onRemove && (
                  <IconButton onClick={() => onRemove(idx, value)} title="Usuń wiersz">
                    <DeleteIcon />
                  </IconButton>
                )}
              </>
            ) : undefined
          }
          data-testid="note-stamped-list-item"
        >
          <ListItemText
            secondary={expanded === idx ? <span style={{ whiteSpace: "pre-line" }}>{value.author}</span> : undefined}
            title={value.tooltip}
          >
            <i style={{ paddingRight: 7 }}>{value.date.format(dateFormat)}:</i>
            {value.text}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};
